import SortNavItem from "./SortNavItem";
import React from "react";

const SortNav = (props: any) => {
  const { listStyle, extraId, inline, tabs, handler, extraClasses, margStyle } = props;
  /*    let style={
    width: "100%"
   };
   if(typeof inline !== "undefined"){
       style = {
           ...style,
           padding: "1rem",
           display:'flex'
       };
   }
   if (props.listStyle && props.listStyle === "tight") {
       style.paddingLeft = "0px"
    }
   let mainStyle = {height: "47px"};
   if(typeof margStyle !== 'undefined'){
       mainStyle.marginBottom = margStyle;
   }*/
  let mainStyle = {};
  if (typeof margStyle !== "undefined") {
    mainStyle = margStyle;
  }
  return (
    <div
      style={mainStyle}
      className={"hide-for-small-only " + typeof extraClasses !== "undefined" ? extraClasses : ""}
    >
      <div
        id={"inb-c-main-sort-nav"}
        className={typeof extraId !== "undefined" ? extraId : ""}
        data-resize="inb-c-main-sort-nav"
      >
        <ul className="inb-tabs" /* style={style} */>
          {tabs.map((tab: any, index: any) => {
            return <SortNavItem tab={tab} key={index} handler={handler} />;
          })}
        </ul>
      </div>
    </div>
  );
};

export default SortNav;
